import { openMetadataApiClient } from '@/shared/api/core/axios-instance';
import type { OpenMetadataTag } from '@/shared/api/openmetadata/types';

export type MLModel = {
  id: string;
  name: string;
  displayName?: string;
  fullyQualifiedName: string;
  description?: string;
  deleted?: boolean;
  algorithm?: string;
  owners?: Array<{
    id: string;
    name: string;
    displayName?: string;
    type: string;
  }>;
  tags?: OpenMetadataTag[];
};

type SearchHit = {
  _id: string;
  _source: {
    id: string;
    name: string;
    displayName?: string;
    fullyQualifiedName: string;
    description?: string;
    deleted?: boolean;
    algorithm?: string;
    owners?: Array<{
      id: string;
      name: string;
      displayName?: string;
      type: string;
    }>;
    tags?: OpenMetadataTag[];
  };
};

type SearchResponse = {
  hits: {
    total: {
      value: number;
    };
    hits: SearchHit[];
  };
};

export type MLModelsResponse = {
  data: MLModel[];
  paging?: {
    total: number;
  };
};

export type FetchMLModelsOptions = {
  includeDeleted?: boolean;
};

export const fetchServiceMLModels = async (
  serviceName: string,
  options: FetchMLModelsOptions = {}
): Promise<MLModelsResponse> => {
  const { includeDeleted = false } = options;

  const queryFilter = {
    query: {
      match: {
        'service.name.keyword': serviceName,
      },
    },
  };

  const response = await openMetadataApiClient.get<SearchResponse>('/search/query', {
    params: {
      q: '',
      index: 'all',
      from: 0,
      size: 1000,
      query_filter: JSON.stringify(queryFilter),
    },
  });

  const mlmodels: MLModel[] = response.data.hits.hits
    .filter((hit) => includeDeleted || !hit._source.deleted)
    .map((hit) => ({
      id: hit._source.id,
      name: hit._source.name,
      displayName: hit._source.displayName,
      fullyQualifiedName: hit._source.fullyQualifiedName,
      description: hit._source.description,
      deleted: hit._source.deleted,
      algorithm: hit._source.algorithm,
      owners: hit._source.owners,
      tags: hit._source.tags,
    }));

  return {
    data: mlmodels,
    paging: {
      total: response.data.hits.total.value,
    },
  };
};
